import React from 'react';
import { Heart, History, CreditCard, Key, BookOpen, LogOut, X } from 'lucide-react';

const Item = ({ icon: Icon, label, onClick, testId, danger }) => (
  <button onClick={onClick} data-testid={testId} className="cud-item"
    style={{ display: 'flex', alignItems: 'center', gap: '0.9rem', width: '100%', padding: '1rem 1.25rem', border: 'none', borderRadius: 12,
      background: 'rgba(255,255,255,0.06)', color: danger ? '#FFB4B4' : 'white', cursor: 'pointer', textAlign: 'left', fontSize: '1.02rem', fontWeight: 500 }}>
    <Icon className="w-5 h-5" style={{ opacity: 0.9 }} />{label}
  </button>
);

// Subscriber menu as a right-side drawer tinted with the catalog's primary colour
export const CatalogUserDrawer = ({ color, name, email, onClose, onFavorites, onHistory, onMySub, onPassword, onSwitch, onLogout }) => (
  <>
    <style>{`@keyframes cudIn{from{transform:translateX(100%)}to{transform:translateX(0)}}@keyframes cudFade{from{opacity:0}to{opacity:1}}
      .cud-item{transition:background-color .2s ease, transform .2s ease}.cud-item:hover{background:rgba(255,255,255,0.14)!important;transform:translateX(-3px)}`}</style>
    <div onClick={onClose} data-testid="user-drawer-backdrop"
      style={{ position: 'fixed', inset: 0, background: 'rgba(5,8,12,0.55)', backdropFilter: 'blur(3px)', zIndex: 1000, animation: 'cudFade .25s ease' }} />
    <aside data-testid="user-drawer" role="dialog" aria-label="Menu do assinante"
      style={{ position: 'fixed', top: 0, right: 0, bottom: 0, width: 'min(88vw, max(520px, 40vw))', zIndex: 1001, color: 'white', textAlign: 'left',
        background: `linear-gradient(160deg, ${color} 0%, ${color} 35%, #0B0F14 140%)`, boxShadow: '-20px 0 60px rgba(0,0,0,0.35)',
        display: 'flex', flexDirection: 'column', padding: '1.5rem', animation: 'cudIn .3s cubic-bezier(.2,.8,.2,1)', overflowY: 'auto' }}>
      <button onClick={onClose} data-testid="user-drawer-close" aria-label="Fechar menu"
        style={{ alignSelf: 'flex-end', background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: 999, width: 40, height: 40, color: 'white', cursor: 'pointer', display: 'grid', placeItems: 'center' }}>
        <X className="w-5 h-5" />
      </button>
      <div style={{ margin: '1rem 0 2rem' }}>
        <p style={{ fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.12em', opacity: 0.7, marginBottom: 6 }}>Olá,</p>
        <p data-testid="user-drawer-name" style={{ fontSize: '1.75rem', fontWeight: 700, lineHeight: 1.15 }}>{name}</p>
        <p data-testid="user-drawer-email" style={{ fontSize: '0.9rem', opacity: 0.8, marginTop: 4, wordBreak: 'break-all' }}>{email}</p>
      </div>
      <nav style={{ display: 'grid', gap: '0.6rem' }}>
        <Item icon={Heart} label="Meus Favoritos" onClick={onFavorites} testId="favorites-btn" />
        <Item icon={History} label="Histórico" onClick={onHistory} testId="history-btn" />
        <Item icon={CreditCard} label="Minha assinatura" onClick={onMySub} testId="my-subscription-btn" />
        <Item icon={Key} label="Alterar Senha" onClick={onPassword} testId="change-password-btn" />
        {onSwitch && <Item icon={BookOpen} label="Trocar plataforma" onClick={onSwitch} testId="switch-platform-btn" />}
      </nav>
      <div style={{ marginTop: 'auto', paddingTop: '1.5rem' }}>
        <Item icon={LogOut} label="Sair" onClick={onLogout} testId="logout-btn" danger />
      </div>
    </aside>
  </>
);
